import { styleOverrides } from "./styleOverrides";

const MuiChip = {
  styleOverrides,
};

export { MuiChip };
